import {FC} from 'react';
import {useForm} from 'react-hook-form';
import {create, InstanceProps} from 'react-modal-promise';
import {yupResolver} from '@hookform/resolvers/yup';
import {Button, Dialog, DialogActions, DialogContent} from '@mui/material';
import {InferType, object} from 'yup';

import {DialogTitle, InputType, RhfNumberInput} from '@shared/components';
import {numberTransformEmptyStringToNull} from '@shared/utils';

interface DialogProps {
  title?: string;
  label?: string;
}

type Props = InstanceProps<number, void> & DialogProps;

const v8nSchema = object().shape({
  amount: numberTransformEmptyStringToNull.integer().required(),
});

type FormValues = InferType<typeof v8nSchema>;

const TopUpBalanceDialog: FC<Props> = ({
  onReject,
  onResolve,
  title = 'Top up balance',
  label = 'Amount (in US dollars)',
}) => {
  const {control, handleSubmit} = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(v8nSchema),
    defaultValues: {
      amount: 5,
    },
  });

  const onSubmit = ({amount}: FormValues): void => {
    onResolve(amount);
  };

  const handleClose = () => {
    onReject();
  };

  return (
    <Dialog onClose={handleClose} open={true}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <DialogTitle title={title} onClose={handleClose} />

        <DialogContent
          sx={{
            minWidth: 300,
            paddingTop: '30px !important',
            paddingBottom: '20px',
          }}
        >
          <RhfNumberInput
            name="amount"
            label={label}
            control={control}
            inputType={InputType.positiveInteger}
          />
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              onReject();
            }}
          >
            Cancel
          </Button>

          <Button type="submit" fullWidth>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export const openTopUpRealDialog = create<DialogProps, number>(
  TopUpBalanceDialog,
);
export const openTopUpPromoDialog = create<DialogProps, number>(
  TopUpBalanceDialog,
);
export const openTopUpCoinsDialog = create<DialogProps, number>(
  TopUpBalanceDialog,
);
export const openTopUpCfpDialog = create<DialogProps, number>(
  TopUpBalanceDialog,
);
